// src/store/useRoleStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface RoleState {
	role: string | null;
	saveRole: (role: string) => void;
	clearRole: () => void;
}

export const useRoleStore = create<RoleState>()(
	persist(
		(set) => ({
			role: null,
			saveRole: (role: string) => set({ role }),
			clearRole: () => set({ role: null })
		}),
		{
			name: 'role-storage'
		}
	)
);
